var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaveBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1366 841.89",
    style: {
      enableBackground: "new 0 0 1366 841.89"
    },
    xmlSpace: "preserve",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#gradient_01_3_);}\n\t.st1{fill:url(#gradient_01-2_1_);}\n\t.st2{fill:url(#gradient_01_4_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_01_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.5853,
    y1: 842.0475,
    x2: 386.5853,
    y2: 840.8195,
    gradientTransform: "matrix(1367.038 0 0 -527.6812 -527793.8125 444332.5938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#633ca3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#321e52"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "gradient_01_1_",
    className: "st0",
    d: "M337.23,526.68c334.53-8.21,384.57-112.79,816.53-99.42 c82.37,2.55,152.58,15.92,212.24,35.86V0L0,0v488.32C59.93,509.74,163.88,530.93,337.23,526.68z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveBg);
export default __webpack_public_path__ + "static/media/wave-bg.8d4df0b6cf7f51d015193f9c7f8cbafa.svg";
export { ForwardRef as ReactComponent };